import { forwardRef } from 'react';
import MaterialSwitch, { SwitchProps } from '@mui/material/Switch';

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
    (props, ref) => {
        return (
            <MaterialSwitch
                ref={ref}
                data-testid={'Switch-container'}
                {...props}
            />
        );
    }
);

export default Switch;
